/* eslint-disable no-useless-escape */
export const formUrl = (input) => {
  const isUrl = /\b(https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*))/g;
  return isUrl.test(input);
};
